<script setup>
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

  const layoutStore = useLayoutStore()
</script>

<template>
  <button class="hamburger-button-mobile" type="button" aria-label="Toggle Sidebar">
    <i class="pi pi-bars" @click.prevent="layoutStore.toggleSidebar()"></i>
  </button>
</template>

<style lang="scss" scoped>
  .hamburger-button-mobile {
    @include resetButton;
    @include focusRing;
    color: inherit;
  }
</style>
